import RecapKeepShoppingFor from 'components/Content/Recap/RecapKeepShoppingFor/RecapKeepShoppingFor';

export default RecapKeepShoppingFor;
